import { render, staticRenderFns } from "./crownButton.vue?vue&type=template&id=09d8a8ac&scoped=true&"
import script from "./crownButton.vue?vue&type=script&lang=js&"
export * from "./crownButton.vue?vue&type=script&lang=js&"
import style0 from "./crownButton.vue?vue&type=style&index=0&id=09d8a8ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d8a8ac",
  null
  
)

export default component.exports